// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { IndexForms } from "@hex-insights/app-modules";
import { SearchForm } from "../../../../Components/Search";
import * as PostFilterFormValues from "../form-values";
import { StandardFilters } from "./Standard";

export type SearchProps = IndexForms.SearchFormProps;

/**
 * Search form of the Post model.
 */
export function Search(props: SearchProps) {
	return <SearchForm {...props} />;
}

export type FilterControllerProps = Omit<
	IndexForms.FilterFormControllerProps<string, PostFilterFormValues.FilterFormValues>,
	"StandardFilters" | "advancedFilterInformation"
>;

/**
 * Filter form of the Post model.
 */
export function FilterController(props: FilterControllerProps) {
	return (
		<IndexForms.FilterFormController
			{...props}
			StandardFilters={StandardFilters}
			advancedFilterInformation={PostFilterFormValues.advancedFilterInformation}
		/>
	);
}
